import { render } from "./MsgModal.vue?vue&type=template&id=44697f22"
import script from "./MsgModal.vue?vue&type=script&lang=js"
export * from "./MsgModal.vue?vue&type=script&lang=js"

import "./MsgModal.vue?vue&type=style&index=0&id=44697f22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__